



























































import {
  Vue,
  Component,
  Prop
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import moment from "moment";
import { formatCurrency } from "@/shared/currency";
import { BillingHistoryMonth, FeeWaiverType, PayerType, BillingFeeExclusionType } from "@/employer/types";
import { useBillingHistoryStore } from "@/employer/store/billingHistory";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class AccountHolderBilling extends Vue {
  billingHistoryStore = useBillingHistoryStore();

  moment = moment;
  formatCurrency = formatCurrency;

  @Prop()
  username: string;

  @Prop()
  partnerId: number;

  get isLoaded () {
    return this.billingHistoryStore.yearsLoaded && this.billingHistoryStore.yearIsLoaded(this.billingHistoryStore.selectedYear);
  }

  mounted () {
    this.billingHistoryStore.loadYears({ username: this.username, partnerId: this.partnerId });
  }

  handleYearChange (value): void {
    this.billingHistoryStore.updateSelectedYear({ year: value, username: this.username, partnerId: this.partnerId });
  }

  getWaiverThreadhold (month: BillingHistoryMonth): string {
    if (month.feeWaiverType === FeeWaiverType.None) {
      return "N/A";
    }
    else {
      return formatCurrency(month.feeWaiverThreshold);
    }
  }

  getWaiverType (month: BillingHistoryMonth): string {
    switch (month.feeWaiverType) {
      case FeeWaiverType.Balance: {
        return "Cash Balance";
      }
      case FeeWaiverType.BalanceAndInvestment: {
        return "Cash + Investment Balance";
      }
      default: {
        return "None";
      }
    }
  }

  getFeeExclusion (month: BillingHistoryMonth): string {
    switch (month.feeExclusionType) {
      case BillingFeeExclusionType.BankAccount: {
        return "Bank Account";
      }
      case BillingFeeExclusionType.FutureEligibility: {
        return "Future Eligibility";
      }
      case BillingFeeExclusionType.Termination: {
        return "Termination";
      }
      case BillingFeeExclusionType.BlockedEmployer: {
        return "Blocked Employer";
      }
      case BillingFeeExclusionType.DuplicateEmployers: {
        return "Duplicate Employers";
      }
      case BillingFeeExclusionType.AverageBalanceThreshold: {
        return "Average Balance Threshold";
      }
      case BillingFeeExclusionType.BendPartnerConditional: {
        return "Bend Partner Conditional";
      }
      case BillingFeeExclusionType.FutureFeeStartDate: {
        return "Future Fee Start Date";
      }
      case BillingFeeExclusionType.ClosedAccount: {
        return "Closed Account";
      }
      default: {
        return "None";
      }
    }
  }

  getPayer (month: BillingHistoryMonth): string {
    switch (month.payerType) {
      case PayerType.Employer: {
        return "Employer";
      }
      case PayerType.Employee: {
        return "Employee";
      }
      case PayerType.Individual: {
        return "Individual";
      }
      default: {
        return "None";
      }
    }
  }
}
